import { render, staticRenderFns } from "./specifyAdjustments.vue?vue&type=template&id=fb8519e2&scoped=true&"
import script from "./specifyAdjustments.vue?vue&type=script&lang=js&"
export * from "./specifyAdjustments.vue?vue&type=script&lang=js&"
import style0 from "./specifyAdjustments.vue?vue&type=style&index=0&id=fb8519e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8519e2",
  null
  
)

export default component.exports